import { render } from "./MindGarden.vue?vue&type=template&id=b6478178&scoped=true"
import script from "./MindGarden.vue?vue&type=script&lang=js"
export * from "./MindGarden.vue?vue&type=script&lang=js"

import "./MindGarden.vue?vue&type=style&index=0&id=b6478178&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6478178"]])

export default __exports__